/*
 * @Author: Gaho
 * @Date: 2024-03-20 14:35:13
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-15 14:49:47
 * @Description: 
 */


export enum MailType {
    system = 'system',
    person = 'person',
}

export enum MailTypeNum {
    system = 0,
    person = 1,
}


export interface MailInfo{
    pagenum: number; // 每页行数 
    id?: number; // 上一次返回的数据列表中最小的id）缓存的最小id， 没有就传-1，或者不传这个字段
    type: number; // 邮件类型 1、个人 0、系统
    isread?: number; // 0未读 1已读, 不传可查全部
}

export interface MailSetRead{
    type: MailTypeNum; // 1、个人 0、系统（必传）
    ids?: Array<number>; // 邮件ID（不是全部已读时必传）
    isReadAll?: number;  // 1是，0否，
}


